/**
 * React Query tuning for Profile / Mi contenido.
 * Local/dev must not reuse dashboard or content payloads — programId writes
 * (classify, hashtag config) should show up on the next navigation.
 */
const isLocalDev = process.env.NODE_ENV === "development";

export const PROFILE_STALE_MS = isLocalDev ? 0 : 2 * 60 * 1000;
export const PROFILE_COMPANY_STALE_MS = isLocalDev ? 0 : 5 * 60 * 1000;
/** Keep cached rows after unmount so back-navigation can reuse data; must be >= max staleTime in this tree. */
export const PROFILE_GC_MS = isLocalDev ? 0 : 10 * 60 * 1000;
